<template>
    <footer>
        <div class="footer" id="footer">
            <div class="container headerOffset">
                <div class="row footerOffset">
                    <div class="col-lg-offset-1 col-lg-1 col-md-2 col-sm-2 col-xs-3 text-center">
                        <router-link :to="{ name: 'shares' }">郵包分享</router-link>
                        <span class="gap">|</span>
                    </div>
                    <div class="col-lg-1 col-md-2 col-sm-2 col-xs-3 text-center">
                        <router-link :to="{ name: 'news' }">最新消息</router-link>
                        <span class="gap">|</span>
                    </div>
                    <div class="col-lg-1 col-md-2 col-sm-2 col-xs-3 text-center">
                        <router-link :to="{ name: 'websites', params: { zone_code: 'cn' } }">推薦商戶</router-link>
                        <span class="gap">|</span>
                    </div>
                    <div class="col-lg-1 col-md-2 col-sm-2 col-xs-3 text-center">
                        <router-link :to="{ name: 'faq' }">常見問題</router-link>
                        <span class="gap hidden-xs">|</span>
                    </div>
                    <div class="col-lg-1 col-md-2 col-sm-2 col-xs-3 text-center">
                        <router-link :to="{ name: 'process' }">代運流程</router-link>
                        <span class="gap">|</span>
                    </div>
                    <div class="col-lg-1 col-md-2 col-sm-2 col-xs-3 text-center">
                        <router-link :to="{ name: 'price-list' }">代運收費</router-link>
                        <span class="gap">|</span>
                    </div>
                    <div class="col-lg-1 col-md-2 col-sm-2 col-xs-3 text-center">
                        <router-link :to="{ name: 'notice' }">注意事項</router-link>
                        <span class="gap">|</span>
                    </div>
                    <div class="col-lg-1 col-md-2 col-sm-2 col-xs-3 text-center">
                        <router-link :to="{ name: 'contact-us' }">聯絡資料</router-link>
                        <span class="gap hidden-xs">|</span>
                    </div>
                    <div class="col-lg-1 col-md-2 col-sm-2 col-xs-3 text-center">
                        <router-link :to="{ name: 'cooperation' }">業務合作</router-link>
                        <span class="gap">|</span>
                    </div>
                    <div class="col-lg-1 col-md-2 col-sm-2 col-xs-3 text-center">
                        <router-link :to="{ name: 'about-us' }">關於我們</router-link>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-offset-2 col-lg-3 col-md-4 col-sm-4 col-xs-6 text-center">
                        <router-link :to="{ name: 'terms' }">服務使用條款及免責聲明</router-link>
                        <span class="gap hidden-xs">|</span>
                    </div>
                    <div class="col-lg-2 col-md-4 col-sm-4 col-xs-6 text-center">
                        <router-link :to="{ name: 'privacy' }">私隱政策聲明</router-link>
                        <span class="gap hidden-xs">|</span>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12 text-center">
                        Copyright © 2014 - {{ new Date | moment("YYYY") }} Uniports.
                    </div>
                </div>
                <div class="text-center m-t-15">
                    <img src="//www.paypalobjects.com/webstatic/en_US/i/buttons/cc-badges-ppppcmcvdam.png"
                         alt="Pay with PayPal, PayPal Credit or any major credit card" class="mobile-img">
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
  export default {
    name: 'SiteFooter',
  };
</script>

<style lang="scss">
    @media screen and (max-width: 414px) {
        .mobile-img {
            width: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/SiteFooter.vue